import React from "react";
import "./NotificationsButton.css";
import vect4 from "../../img/vector-4@2x.svg"
import right4 from "../../img/right@2x.svg"

const NotificationsButton = () => {

    return (
        <div className="notifications-button">
            <div className="overlap-group1">
                <div className="overlap-group-57">
                    <img className="vector-44" src={vect4} />
                    <div className="ellipse-462"></div>
                </div>
                <div className="ellipse-463-20"></div>
            </div>
            <div className="group-1000006416">
                <div className="notifications nunito-bold-black-14px">Notifications</div>
                <img className="right-4" src={right4} />
            </div>
        </div>
    );
}

export default NotificationsButton;